import { Input, Label, Switch } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { AITagFormProps } from './tag-form.type'

import styles from './tag-form.module.css'

export const TagForm = ({ onChangeValues, values, errors }: AITagFormProps) => {
  const { t } = useTranslation('screenAiCenter')

  const onHandleValues = (key: string, value: string | number | boolean) => {
    onChangeValues({ ...values, [key]: value })
  }

  return (
    <div className={styles.core}>
      <div>
        <Label>{t('tagFormSlugLabel')}</Label>
        <Input
          placeholder={t('tagFormSlugPlaceholder')}
          value={values?.slug}
          onChange={(newValue) => onHandleValues('slug', newValue)}
          error={errors?.slug as string}
        />
      </div>

      <div>
        <Label>{t('tagFormColorLabel')}</Label>
        <Input
          placeholder={t('tagFormColorPlaceholder')}
          value={values?.color}
          onChange={(newValue) => onHandleValues('color', newValue)}
          type="color"
          error={errors?.color as string}
        />
      </div>

      <div>
        <Label>{t('tagFormDescriptionLabel')}</Label>
        <Input
          placeholder={t('tagFormDescriptionPlaceholder')}
          isTextArea
          value={values?.description}
          onChange={(newValue) => onHandleValues('description', newValue)}
          error={errors?.description as string}
        />
      </div>

      <div>
        <Label>{t('agentFormActiveLabel')}</Label>
        <Switch
          checked={values?.active || false}
          onChange={(checked) => onHandleValues('active', checked)}
        />
      </div>
    </div>
  )
}
